export const LAUNCHTIME = '2023/05/31 00:00:00';
export const LOCALE_ARR = ['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'cn', 'jp', 'za'];
